import { TooltipIcon } from "components";
import { UserGuideLink } from "constants/links";
import { Link } from "react-router-dom";

export function UserGuide() {
    return (
        <div className="noti-icon user-guide pe-1">
            <Link to={UserGuideLink} target="_blank">
                <TooltipIcon text="User Guide" icon="dripicons-question" placement="bottom" classes={[]} style={{height:"60px"}} />
            </Link>
        </div>
    );
}